import * as React from 'react';
import * as Tgcc from '../tgccGlobal';
import * as Redux from 'redux'
import Radium, { StyleRoot } from 'radium';
import {connect} from 'react-redux';
import {MajorAccountsHdr} from '../Components/MajorAccountsHdr';
import { MajorAccountsFooter } from '../Components/MajorAccountsFooter';
import * as Request from '../tgccRequest'

const boxStyle: React.CSSProperties = {
    position: 'relative',
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    fontSize:'17px',
    color:'#404041',
};

const contentBox: React.CSSProperties = {
    padding:'5px',
    overflow:'auto',
    height:'92%',
    display:'flex',
    flexWrap:'wrap',
    margin:'20px auto'
}

const instructStyle: React.CSSProperties = {
    textAlign:'center'
}
const serviceLiStyle: React.CSSProperties = {
    fontSize:'13px',
    marginBottom:'10px'
}
const contentDiv:React.CSSProperties = {
    backgroundColor:'white',
    height:'195px',
    borderRadius:'10px',
    position:'relative'
}
const listStyle: React.CSSProperties = {
    width:'75%',
    position:'relative',
    top:'20px'
}

const downloadLi: React.CSSProperties = {
    fontSize:'12px',
    marginBottom:'10px',
    color:'#E27558'
}

const bottomOL: React.CSSProperties = {
    fontFamily:"BarlowLight",
    fontSize:'12px',
    position:'absolute',
    left:'50%',
    marginLeft:'-81px',
    bottom:'0px'
}

var bottomOL1 = Object.assign({},bottomOL,{position:'unset',left:'unset',marginLeft:'unset',bottom:'unset',textAlign:'center',marginTop:"15px"})

class Service {
    key:number;
    description:any;
    title:string;
    subtitle:string;
    btnText:string;
}

let Services: Service[] = [
    {
        key:4,
        description:<div style={contentDiv}><ol style={listStyle}><li style={serviceLiStyle}>Choose Credit Card, Check, or Purchase order.</li><li style={serviceLiStyle}>Provide your sizes and shipping info.</li><li style={serviceLiStyle}>Approve your design.</li><li style={serviceLiStyle}>We contact you to complete payment.</li></ol><div style={bottomOL}>(All orders ship to one location.)</div></div>,
        title:"Traditional",
        subtitle:"Submit one payment for your entire order.",
        btnText:"Traditional"
    },
    {
        key:1,
        description:<div style={contentDiv}><ol style={listStyle}><li style={serviceLiStyle}>Estimate your order quantity.</li><li style={serviceLiStyle}>Provide your shipping info.</li><li style={serviceLiStyle}>We email you a payment link to share with your participants so they can select quantities and sizes and pay on their own.</li></ol><div style={bottomOL1}>(All orders ship to one location. Must meet qty. minimums.)</div></div>,
        title:"Individual Payment Link",
        subtitle:"Allow individuals to purchase through a web link.",
        btnText:"Individual"
    }
];

const imgStyle: React.CSSProperties = {
    maxHeight: '35px',
    maxWidth: '70px',
}
const containerStyle: React.CSSProperties = {
    padding:'10px',
    width:'310px',
    height:'350px',
    backgroundColor:'#E9E6E6',
    borderRadius:'20px',
    fontFamily:'BarlowMedium',
    color:'#616060',
    marginRight:'15px',
    marginBottom:'10px',
}
const serviceTitle: React.CSSProperties = {
    position:'relative',
    top:'5px',
    fontFamily:'BarlowMedium',
    fontSize:'20px',
    textTransform:'uppercase'
    
}
const cowTagStyle: React.CSSProperties = {
    width:'35px',
    height:'70px',
    position:'relative',
    left:'2%'
}
const icontitleDiv: React.CSSProperties = {
    textAlign:'center'
}

const cowTagDownStyle: React.CSSProperties = {
    margin:'auto',
    width: '285px',
    backgroundColor:'#E27558',
    color:'white',
    padding:'5px',
    height:'54px',
    fontFamily:'Lulo',
    textAlign:'center',
    display:'flex',
    justifyContent:'center',
    alignItems:'center'
}

var paymentBtn = Object.assign({},cowTagDownStyle,{width:'270px',cursor:'pointer',margin:'20px auto'});

const dashHdrLineR: React.CSSProperties = {
    width:'180px',
    backgroundColor:'#E9E6E6',
    height:'2px',
    display:'inline-block',
    marginBottom:'8px',
    marginRight:'10px',
    position:'relative'
}

const dashHdrLineL: React.CSSProperties = {
    width:'180px',
    backgroundColor:'#E9E6E6',
    height:'2px',
    display:'inline-block',
    marginBottom:'8px',
    marginLeft:'5px'
}

const dashText: React.CSSProperties = {
    display:'inline-block',
    letterSpacing:'0.3em',
    fontSize:'26px',
    fontFamily:'Lulo',
    color:'#686868'
}
const hdrCont: React.CSSProperties = {
    marginTop:'50px',
    textAlign:'center'
}

const cowTagDiv: React.CSSProperties = {
    fontFamily:'BarlowMedium',
    color:'rgb(97, 96, 96)',
    textAlign:'center',
    marginTop:'25px'
}
const cowTagUl: React.CSSProperties = {
    listStyleType:'none'
}

const cowTagHdr: React.CSSProperties = {
    fontSize:'25px',
    textTransform: 'uppercase'
}

const subTitleStyle: React.CSSProperties = {
    fontFamily:"BarlowLight",
    fontSize:'12px',
}
class svcProps extends Tgcc.BaseProps{
    proof: Tgcc.Proof;
}

export class _MajorAccountsPaymentOptions extends React.Component<svcProps, any> {

    init = (login: Tgcc.LoginData) => {
        if(login){
            var proofId = this.props.location.query.proofId;
            Request.getProof(login, proofId, this.proofLoaded, this.loadError);
        }
    }

    componentWillMount(){
        if(this.props.state.LoginData)
            this.init(this.props.state.LoginData);
        else
            Tgcc.LoginUser( this.props.dispatch);
    }
    componentDidMount(){
        var tag = document.getElementById('paymentOptions');
        tag.scrollIntoView(false);
    }
    
    scrollPageToView = (id: string) => {
        var el = document.getElementById(id);
        var scroller = document.getElementById("Scroller");
        scroller.scrollTop = el.offsetTop - 75;
    }
    
    componentWillReceiveProps(props: any){
        if(props.state.LoginData)
            this.init(props.state.LoginData);
    }

    proofLoaded = (proof: Tgcc.Proof) => {
        this.setState({proof: proof});
    }
    loadError = (err: any) => {
        console.log("error loading proof: ", err);
    }
    cancel = () => {
        this.props.dispatch({type: Tgcc.StateAction.DialogAction, payload: null});
    }
    showService = (service: Service) => {
        this.props.dispatch({type: Tgcc.StateAction.DialogAction, payload:{action: Tgcc.DialogAction.MajorAccountsServiceContext, payload: { title:service.title, description:service.description, proof: this.state.proof}}});
    }
    getDashHeader(){
        return (
            <div style={hdrCont} className='createAcct'>
                <div style={dashHdrLineR}></div>
                <h1 style={dashText}>PICK YOUR PAYMENT OPTION</h1>
                <div style={dashHdrLineL}></div>

            </div>
        )
    }
    
    render() {
        return (
            <div>
            <div id='paymentOptions'></div>
                <MajorAccountsHdr />
                {this.getDashHeader()}
                <div style={boxStyle} className="corpOuterBox">
                        <div style={contentBox} className="corpPaymentBox">
                            {Services.map((service: Service) => {return <div key={service.key} style={containerStyle} className="corpPaymentDiv"><div style={icontitleDiv}><div style={serviceTitle}>{service.title}</div><div style={subTitleStyle}>{service.subtitle}</div></div>{service.description}<div style={paymentBtn} onClick={() => this.showService(service)}>Select {service.btnText}</div></div>})}
                        </div>                       
                            <div style={cowTagDiv}>
                                <div style={cowTagHdr}>Would you like your order Cow Tagged&#63;</div>
                                <ul style={cowTagUl} className="corpCowTagUl">
                                    <li>We&#39;ll fold, polybag, and label each shirt with individual names for only &#36;0.75 each.</li>
                                    <li>Fold and polybag only available for &#36;0.50 each.</li>
                                    <li>If bagging by name, send your account manager a completed cow tagging form available in the link below.</li>
                                    <li>If bagging by size, let your account manager know at the time your order is finalized.</li>
                                </ul>
                            </div>
                            <div className="cowTagDownload" style={cowTagDownStyle}>
                                <a href={Tgcc.ResolveUrl("~/images/Cow_Tag_Form_Collegiate_2018.xls")} download>Download Cow Tag Form</a>
                            </div>

                </div>
                <MajorAccountsFooter state={this.props.state} />
            </div>           
        )
    }
}

const mapStateToProps = (state : Tgcc.GlobalState, ownState: any) => {
    return { state: state };
};
export var MajorAccountsPaymentOptions = connect(mapStateToProps)(Radium(_MajorAccountsPaymentOptions));
